function systemalert(message, type) {

    var html =  '<div class="alert alert-' + type + ' alert-dismissable">';
    html +=     '<button type="button" class="close"><span aria-hidden="true">×</span><span class="sr-only">Close</span></button>';
    html +=     message;
    html +=     '</div>';

    var html = $(html);

    $('.close', html).on('click', function(){
       $(this).parent('.alert').slideUp(200, function(){
           $(this).remove();
       })
    });

    html.hide().prependTo('#systemalerts').slideDown(200, function(){
        setTimeout(function(){
            $(this).slideUp(200, function(){
                $(this).remove();
            })
        }.bind(this), 5000);
    });
};

$( function () {

    // Examples to add live systemalerts
    // systemalert('test', 'info');
    // systemalert('success', 'success');
    // systemalert('warning', 'warning');
    // systemalert('danger', 'danger');
    // systemalert('info', 'info');

    $('.alert', '#systemalerts').each( function() {
        $(this).slideDown(200, function(){
            setTimeout(function(){
                $(this).slideUp(200, function(){
                    $(this).remove();
                })
            }.bind(this), 5000);
        });
    });

    $('.close', '#systemalerts').click( function(e) {
        e.preventDefault();
        $(this).closest('.alert').slideUp(200, function(){
            $(this).remove();
        });
    });

    $('#flash-overlay-modal').modal();

});